
import { Grouping } from './grouping';
import { Ordering } from './ordering';
import { Projection } from './projection';
import { FilterGroup } from '../filtering/filter-group';

export class Query {
  Projects?: Array<string>;
  Group: string;
  Projections?: Array<Projection>;
  Groupings?: Array<Grouping>;
  FilterGroup?: FilterGroup;
  PreFilterGroup?: FilterGroup;
  Orderings?: Array<Ordering>;

  Skip?: number;
  Take?: number;

  IncludeHasDocuments?: boolean;

  constructor() {
    this.Projects = null; // Currently, the WebAPI can't accept a missing or empty projects array - it needs to be explicitly set to null
    this.Projections = new Array<Projection>();
    this.Groupings = new Array<Grouping>();
    this.IncludeHasDocuments = false;
  }

  addProjects?(projects: Array<string>) {
    this.Projects = projects;
  }

  addProjection?(entity: string, property: string) {
    const projection: Projection = { Group: entity, Header: property };
    this.Projections.push(projection);
  }

  addGrouping?(entity: string, property: string, aggregate: string) {
    const grouping: Grouping = { Group: entity, Header: property, Aggregate: aggregate };
    this.Groupings.push(grouping);
  }

  addOrdering?(entity: string, property: string, ascending: boolean) {
    const ordering: Ordering = { Group: entity, Header: property, Ascending: ascending };
    this.Orderings.push(ordering);
  }
}
